"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  [![Run in Postman](https://run.pstmn.io/button.svg)](https://app.getpostman.com/run-collection/614feab5c108d292bffa#?env%5BStacks%20Blockchain%20API%5D=W3sia2V5Ijoic3R4X2FkZHJlc3MiLCJ2YWx1ZSI6IlNUMlRKUkhESE1ZQlE0MTdIRkIwQkRYNDMwVFFBNVBYUlg2NDk1RzFWIiwiZW5hYmxlZCI6dHJ1ZX0seyJrZXkiOiJibG9ja19pZCIsInZhbHVlIjoiMHgiLCJlbmFibGVkIjp0cnVlfSx7ImtleSI6Im9mZnNldCIsInZhbHVlIjoiMCIsImVuYWJsZWQiOnRydWV9LHsia2V5IjoibGltaXRfdHgiLCJ2YWx1ZSI6IjIwMCIsImVuYWJsZWQiOnRydWV9LHsia2V5IjoibGltaXRfYmxvY2siLCJ2YWx1ZSI6IjMwIiwiZW5hYmxlZCI6dHJ1ZX0seyJrZXkiOiJ0eF9pZCIsInZhbHVlIjoiMHg1NDA5MGMxNmE3MDJiNzUzYjQzMTE0ZTg4NGJjMTlhODBhNzk2MzhmZDQ0OWE0MGY4MDY4Y2RmMDAzY2RlNmUwIiwiZW5hYmxlZCI6dHJ1ZX0seyJrZXkiOiJjb250cmFjdF9pZCIsInZhbHVlIjoiU1RKVFhFSlBKUFBWRE5BOUIwNTJOU1JSQkdRQ0ZOS1ZTMTc4VkdIMS5oZWxsb193b3JsZFxuIiwiZW5hYmxlZCI6dHJ1ZX0seyJrZXkiOiJidGNfYWRkcmVzcyIsInZhbHVlIjoiYWJjIiwiZW5hYmxlZCI6dHJ1ZX0seyJrZXkiOiJjb250cmFjdF9hZGRyZXNzIiwidmFsdWUiOiJTVEpUWEVKUEpQUFZETkE5QjA1Mk5TUlJCR1FDRk5LVlMxNzhWR0gxIiwiZW5hYmxlZCI6dHJ1ZX0seyJrZXkiOiJjb250cmFjdF9uYW1lIiwidmFsdWUiOiJoZWxsb193b3JsZCIsImVuYWJsZWQiOnRydWV9LHsia2V5IjoiY29udHJhY3RfbWFwIiwidmFsdWUiOiJzdG9yZSIsImVuYWJsZWQiOnRydWV9LHsia2V5IjoiY29udHJhY3RfbWV0aG9kIiwidmFsdWUiOiJnZXQtdmFsdWUiLCJlbmFibGVkIjp0cnVlfV0=)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoreNodeInfoResponseToJSON = exports.CoreNodeInfoResponseFromJSONTyped = exports.CoreNodeInfoResponseFromJSON = void 0;
function CoreNodeInfoResponseFromJSON(json) {
    return CoreNodeInfoResponseFromJSONTyped(json, false);
}
exports.CoreNodeInfoResponseFromJSON = CoreNodeInfoResponseFromJSON;
function CoreNodeInfoResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'peer_version': json['peer_version'],
        'pox_consensus': json['pox_consensus'],
        'burn_block_height': json['burn_block_height'],
        'stable_pox_consensus': json['stable_pox_consensus'],
        'stable_burn_block_height': json['stable_burn_block_height'],
        'server_version': json['server_version'],
        'network_id': json['network_id'],
        'parent_network_id': json['parent_network_id'],
        'stacks_tip_height': json['stacks_tip_height'],
        'stacks_tip': json['stacks_tip'],
        'stacks_tip_consensus_hash': json['stacks_tip_consensus_hash'],
        'unanchored_tip': json['unanchored_tip'],
        'exit_at_block_height': json['exit_at_block_height'],
    };
}
exports.CoreNodeInfoResponseFromJSONTyped = CoreNodeInfoResponseFromJSONTyped;
function CoreNodeInfoResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'peer_version': value.peer_version,
        'pox_consensus': value.pox_consensus,
        'burn_block_height': value.burn_block_height,
        'stable_pox_consensus': value.stable_pox_consensus,
        'stable_burn_block_height': value.stable_burn_block_height,
        'server_version': value.server_version,
        'network_id': value.network_id,
        'parent_network_id': value.parent_network_id,
        'stacks_tip_height': value.stacks_tip_height,
        'stacks_tip': value.stacks_tip,
        'stacks_tip_consensus_hash': value.stacks_tip_consensus_hash,
        'unanchored_tip': value.unanchored_tip,
        'exit_at_block_height': value.exit_at_block_height,
    };
}
exports.CoreNodeInfoResponseToJSON = CoreNodeInfoResponseToJSON;
//# sourceMappingURL=CoreNodeInfoResponse.js.map